if ($('.js-triggerAnimation').length > 0 && $(window).width() > 767) {
	// let scrollTop = 0;
	// let elem_1 = $('.js-triggerAnimation .elem_1');
	// let elem_4 = $('.js-triggerAnimation .elem_4');
	// let elem_6 = $('.js-triggerAnimation .elem_6');
	// let elem_9 = $('.js-triggerAnimation .elem_9');
	// let elem_10 = $('.js-triggerAnimation .but_blue');
	// let widthEelem = elem_1.outerWidth();

	// $(window).on('scroll load resize', function() {
	// 	const triggerStart = $('.js-triggerStart').offset().top;
	// 	scrollTop = $(window).scrollTop() + $(window).height() / 2;
	// 	widthEelem = elem_1.outerWidth();

	// 	if (scrollTop >= triggerStart) {
	// 		let sum = scrollTop - triggerStart;

	// 		if (sum > widthEelem) {
	// 			sum = widthEelem;
	// 		}

	// 		elem_1.css('transform', `translateX(${sum}px)`);
	// 		elem_9.css('transform', `translateX(${sum}px)`);
	// 		elem_6.css('transform', `translateX(${-sum}px)`);

	// 		if ($(window).width() < 1025) {
	// 			elem_4.css('transform', `translateX(${-sum}px)`);
	// 			elem_10.css('transform', `translateX(${-sum}px)`);
	// 		} else {
	// 			elem_4.css('transform', `translateX(${-sum}px)`);
	// 			elem_10.css('transform', `translateX(${-sum}px)`);
	// 		}

	// 	} else {
	// 		elem_4.css('transform', `translateX(0px)`);
	// 		elem_1.css('transform', `translateX(0px)`);
	// 		elem_9.css('transform', `translateX(0px)`);
	// 		elem_6.css('transform', `translateX(0px)`);
	// 		elem_10.css('transform', `translateX(0px)`);
	// 	}
	// })

	$(window).on('load scroll', () => {
		const section = $('.js-triggerAnimation');
		const scrolled = $(window).scrollTop();
		const halfHeight = $(window).height() / 1.5;

		section.each((index, element) => {
			const block = $(element);
			const blockOffset = block.offset().top - halfHeight;

			if(scrolled >= blockOffset && !block.hasClass('is_animate')){
				block.addClass('is_animate');
			}
		});
	});
}

// if ($('.js-triggerAnimation.automation-images').length > 0 && $(window).width() < 768) {
// 	$(window).on('load scroll', () => {
// 		const section = $('.js-triggerAnimation');
// 		const scrolled = $(window).scrollTop();
// 		const halfHeight = $(window).height() / 1.5;

// 		section.each((index, element) => {
// 			const block = $(element);
// 			const blockOffset = block.offset().top - halfHeight;

// 			if(scrolled >= blockOffset && !block.hasClass('is_animate')){
// 				block.addClass('is_animate');
// 			}
// 		});
// 	});
// }